export const PRODUCT_CATALOG_TAGS_COLLECTION_KEY =
  "natomas/v1/product_catalog_tags";
